import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from './../../../ui/src/component/icon';
import { Pill } from './../../../ui/src/component/pill';
import CsmSectionLink from '../csmSectionLink/csmSectionLink';
import './header.css';
import cx from 'classnames';
// import logo from '../../../assets/radio-ke.png';
import logoVianoce from '../../../assets/RKE_CIAPKA.png';
import logo2x from '../../../assets/radio-ke@2x.png';
import { getProp } from '../../../ui/src/utilities';

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchFocused: false,
    };
    this.searchInputEl = null;

    this.onClickSearchBtn = this.onClickSearchBtn.bind(this);
  }

  onClickSearchBtn(e) {
    e.preventDefault();
    this.setState({ searchFocused: true }, () => {
      this.searchInputEl.focus();
    });
  }

  onBlurSearchInput() {
    this.setState({ searchFocused: false });
    this.searchInputEl.blur();
  }

  onFocusSearchInput() {
    this.setState({ searchFocused: true });
  }

  onKeyDownSearchInput(event) {
    if (event.key === 'Enter') {
      this.setState({ searchFocused: false });
    } else if (event.key === 'Escape') {
      this.searchInputEl.blur();
    }
  }

  onSubmitSearch(ev) {
    ev.preventDefault();
    this.props.onSubmitSearch();
    this.searchInputEl.blur();
  }

  switchChristmasLogo() {
    const now = new Date();
    if (now.getMonth() === 11 || (now.getMonth() === 0 && now.getDate() < 7)) {
      return logoVianoce;
    } else
      return logo2x
  }



  render() {
    return (
      <header id="header">
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-logo">
              <a href="/">
                <img
                  src={this.switchChristmasLogo()}
                  alt="Rádio Košice"
                  className="img-responsive"
                />
              </a>
            </div>
            <div id="focus-search-container">
              <div
                id="focus-search"
                className={cx({ focused: this.state.searchFocused })}
              >
                <form
                  className="input-group search-form"
                  onSubmit={this.onSubmitSearch.bind(this)}
                >
                  <input
                    tabIndex={-1}
                    ref={el => (this.searchInputEl = el)}
                    onBlur={this.onBlurSearchInput.bind(this)}
                    onFocus={this.onFocusSearchInput.bind(this)}
                    onKeyDown={this.onKeyDownSearchInput.bind(this)}
                    type="search"
                    name=""
                    id=""
                    value={this.props.searchQuery}
                    className="form-control"
                    placeholder="Hľadaný výraz"
                    onChange={ev =>
                      this.props.onChangeSearchQuery(ev.target.value)
                    }
                  />
                  <span className="input-group-btn">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      onMouseDown={this.onSubmitSearch.bind(this)}
                    >
                      Hľadať <Icon name="magnifier" />
                    </button>
                  </span>
                </form>
              </div>
            </div>
            <a
              href=""
              className={cx('btn btn-default btn-search hidden-sm hidden-xs', {
                hidden: this.state.searchFocused,
              })}
              onClick={this.onClickSearchBtn}
            >
              <Icon name="magnifier" />
            </a>
            <nav
              className={cx('col-xs-12 col-navigation', {
                hidden: this.state.searchFocused,
              })}
            >
              <ul>
                {getProp(this.props, 'nav', []).map(item => {
                  return (
                    <li key={item._id}>
                      <CsmSectionLink
                        section={item}
                        nested={!!item.sections}
                        sections={item.sections || []}
                      />
                    </li>
                  );
                })}
              </ul>
            </nav>
            <div className="col-xs-12 col-search visible-xs-block visible-sm-block">
              <form
                className="input-group search-form"
                onSubmit={ev => {
                  ev.preventDefault();
                  this.props.onSubmitSearch();
                }}
              >
                <input
                  type="search"
                  name=""
                  id=""
                  value={this.props.searchQuery}
                  className="form-control"
                  placeholder="Hľadaný výraz"
                  onChange={ev =>
                    this.props.onChangeSearchQuery(ev.target.value)
                  }
                />
                <span className="input-group-btn">
                  <button type="submit" className="btn btn-default">
                    <Icon name="magnifier" />
                  </button>
                </span>
              </form>
            </div>
            <div className="col-xs-12 header-buttons">
              <a href="https://www.tvkosice.sk/doprava" target="_blank" rel="noopener noreferrer">
                <Pill content={'Doprava naživo'} />
              </a>
              <a href="https://www.tvkosice.sk/live" target="_blank" rel="noopener noreferrer">
                <Pill content={'Live TV Košice'} />
              </a>
            </div>
          </div>
        </div>
      </header>
    );
  }
}

Header.propTypes = {
  nav: PropTypes.array.isRequired,
  searchQuery: PropTypes.string.isRequired,
  onChangeSearchQuery: PropTypes.func.isRequired,
  onSubmitSearch: PropTypes.func.isRequired,
};

export default Header;



// WEBPACK FOOTER //
// ./src/app/component/header/header.js